const state = {
  selectedDatasetStatus: 'All',
  selectedClassifications: [],
  selectedDataFormats: [],
  selectedText: '',
  selectedCreateDate: 'All',
  selectedPIs: []
}

const mutations = {
  setDatasetStatusFilter (state, payload) {
    state.selectedDatasetStatus = payload
  },
  setClassificationFilter (state, payload) {
    state.selectedClassifications = payload
  },
  setDataFormatFilter (state, payload) {
    state.selectedDataFormats = payload
  },
  setTextFilter (state, payload) {
    state.selectedText = payload
  },
  setCreateDateFilter (state, payload) {
    state.selectedCreateDate = payload
  },
  setPIFilter (state, payload) {
    state.selectedPIs = payload
  }
}

export default {
  state,
  mutations
}
